<template>
    <div>
        <div class="deploy-service-box">
            <h1>HTTP 配置</h1>

            <div v-if="!apiParamObj.api" class="empty-tip">
                请先选择集成开放平台API
            </div>

            <template v-else>
                <div v-for="type in ['Query', 'Header', 'UrlPath']" :key="type" class="row">
                    <div class="tableFormObjWrapper">
                        <span style="font-size: 12px;color: #222c;line-height: 20px;display: inline-block;margin-bottom: 8px">{{ type }}</span>
                        <hc-form ref="tableFormObj" label-position="left" label-width="110px" :model="tableFormObj" :rules="rules">
                            <hc-table
                                :key="`table_${varObj.paramType}`"
                                :data="(tableFormObj.tableDataArr || []).filter(d => d.paramType === type)"
                                row-key="id"
                                :row-class-name="rowClassName"
                                :tree-props="{ children: 'fields' }"
                                :indent="24"
                                @row-click="tableRowClick"
                            >
                                <hc-table-column label="名称" prop="name" show-overflow-tooltip>
                                    <template slot-scope="{ row }">
                                        {{ row.name || row.key }}
                                    </template>
                                </hc-table-column>
                                <hc-table-column label="数据类型" prop="type" width="auto" />
                                <hc-table-column label="描述" prop="remark" show-overflow-tooltip>
                                    <template slot-scope="{ row }">
                                        {{ row.remark || '--' }}
                                    </template>
                                </hc-table-column>
                                <hc-table-column label="必填" width="auto">
                                    <template slot-scope="{ row }">
                                        <span>{{ row.required ? '是' : '否' }}</span>
                                    </template>
                                </hc-table-column>
                            </hc-table>
                        </hc-form>
                    </div>
                </div>

                <template v-if="methodsHasBody.includes(apiParamObj.method)">
                    <span style="font-size: 12px;color: #222c;line-height: 20px;display: inline-block;margin-bottom: 0">Body</span>
                    <hc-form-item v-if="methodsHasBody.includes(apiParamObj.method)" label-width="0">
                        <hc-radio-group v-model.trim="apiParamObj.body.contentType" placeholder="请选择请求体" size="small" disabled>
                            <hc-radio key="form-data" label="multipart/form-data">
                                form-data
                            </hc-radio>
                            <hc-radio key="form-urlencode" label="application/x-www-form-urlencoded">
                                x-www-form-urlencoded
                            </hc-radio>
                            <hc-radio key="octet-stream" label="application/octet-stream">
                                binary
                            </hc-radio>
                            <hc-radio key="json" label="application/json">
                                Raw-Json
                            </hc-radio>
                        </hc-radio-group>
                        <div v-if="apiParamObj.body.contentType === 'application/octet-stream'" class="binary-tip">
                            <i class="hc-icon hc-icon-info">i</i>请求主体（Body）是一段二进制流
                        </div>
                    </hc-form-item>
                    <div v-if="apiParamObj.body.contentType !== 'application/octet-stream'" class="tableFormObjWrapper">
                        <hc-form ref="tableFormRequestObj" label-position="left" :model="tableFormRequestObj" :rules="rules">
                            <hc-table
                                :key="`table_${varObj.paramType}`"
                                :data="tableFormRequestObj.tableDataArr"
                                row-key="id"
                                :row-class-name="rowClassName"
                                :tree-props="{ children: 'fields' }"
                                :indent="12"
                                @row-click="tableRowClick"
                            >
                                <hc-table-column :label="isPairType ? '名称' : '节点名称'" prop="name" show-overflow-tooltip>
                                    <!-- eslint-disable-next-line vue/mustache-interpolation-spacing -->
                                    <template slot-scope="{ row }">
                                        {{ row.name || row.key }} <span style="margin-left: 4px;color: #999">{{ row.type }}</span>
                                    </template>
                                </hc-table-column>
                                <hc-table-column v-if="varObj.paramType === 'params'" label="位置" prop="position" />
                                <hc-table-column label="必填" :width="varObj.paramType === 'request' ? '80px' : '100px'">
                                    <template slot-scope="{ row }">
                                        <span>{{ row.required ? '是' : '否' }}</span>
                                    </template>
                                </hc-table-column>
                                <hc-table-column label="描述" prop="remark" show-overflow-tooltip>
                                    <template slot-scope="{ row }">
                                        <div>
                                            {{ row.remark || '--' }}
                                        </div>
                                    </template>
                                </hc-table-column>
                                <hc-table-column label="处理" width="140px">
                                    <template slot-scope="{ row }">
                                        <div v-if="!row.disable && row.type === 'object'" class="handle">
                                            <div class="handle-form-item handle-type-input" :class="{ 'no-handle': !row.handle }">
                                                <hc-form-item
                                                    :prop="getFormItemProp(row, 'handle')"
                                                    :rules="rules.handle"
                                                >
                                                    <hc-switch v-if="isPairType" :value="row.handle === 'pair'" @change="v => itemHandleChange(row, v, true)" />
                                                    <hc-select v-else v-model="row.handle" placeholder="请选择处理方式" @change="itemHandleChange(row)">
                                                        <hc-option key="params" label="绑定对象" value="params" />
                                                        <hc-option key="noHandle" label="绑定参数" value="noHandle" />
                                                    </hc-select>
                                                </hc-form-item>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <!-- {{ getHandleText(row.handle) }} -->
                                            无
                                        </div>
                                    </template>
                                </hc-table-column>
                                <hc-table-column v-if="apiParamObj.body && apiParamObj.body.type === 'object'" label="关联信息" width="200px">
                                    <template slot-scope="{ row }">
                                        <div v-if="(row.type === 'object' || row.type === 'objectArray') && row.handle === 'params'" class="handle-form-item" @click="objectClick">
                                            <hc-form-item key="object" :prop="getFormItemProp(row, 'objectId')" :rules="rules.objectId">
                                                <object-picker
                                                    v-model="row.objectId"
                                                    :schema="row"
                                                    :object-name.sync="row.objectName"
                                                    :business-env-id="businessEnvId"
                                                    @input="rowObjectChange(row)"
                                                />
                                            </hc-form-item>
                                        </div>
                                        <div v-else>
                                            {{ getRelevanceStr(row) }}
                                        </div>
                                    </template>
                                </hc-table-column>
                                <hc-table-column v-if="varObj.paramType === 'request'" label="参数名称" width="200px">
                                    <template slot-scope="{ row }">
                                        <div>
                                            {{ getNameStr(row) }}
                                        </div>
                                    </template>
                                </hc-table-column>
                            </hc-table>
                        </hc-form>
                    </div>
                </template>
            </template>
        </div>

        <div class="deploy-service-box response-form">
            <h1>
                返回值
            </h1>

            <div v-if="!apiParamObj.api" class="empty-tip">
                请先选择集成开放平台API
            </div>

            <hc-form v-else ref="responseForm" key="responseForm" label-width="112px" :model="apiParamObj.response" :class="{'collapse': responseCollapse}">
                <div class="row">
                    <hc-form-item
                        label="返回类型"
                        prop="dataType"
                        :rules="[{ required: true, message: '请选择数据返回类型', trigger: ['blur', 'change'] }]"
                    >
                        <hc-select
                            v-model.trim="apiParamObj.response.dataType" placeholder="请选择返回类型" size="small"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                        >
                            <hc-option key="string" label="String" value="string" />
                            <hc-option key="number" label="Number" value="number" />
                            <hc-option key="boolean" label="Boolean" value="boolean" />
                            <hc-option key="object" label="Object" value="object" />
                            <hc-option key="objectArray" label="ObjectArray" value="objectArray" />
                            <hc-option key="stringArray" label="StringArray" value="stringArray" />
                            <hc-option key="numberArray" label="NumberArray" value="numberArray" />
                        </hc-select>
                    </hc-form-item>
                    <hc-form-item
                        v-if="apiParamObj.response.dataType === 'object' || apiParamObj.response.dataType === 'objectArray'"
                        :key="apiParamObj.response.objectId"
                        label="业务对象"
                        prop="objectId"
                        :rules="[{ required: true, message: '请选择业务对象', trigger: ['blur'] }]"
                    >
                        <div class="large-picker">
                            <object-picker
                                v-model="apiParamObj.response.objectId"
                                :object-name.sync="apiParamObj.response.objectName"
                                :business-env-id="businessEnvId"
                                :schema="apiParamObj.response.schema"
                                show-add-btn
                                :show-required="false"
                                :api-param-obj="apiParamObj"
                                :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            />
                        </div>
                    </hc-form-item>
                </div>
                <div class="row">
                    <hc-form-item
                        label="判断依据字段"
                        prop="codeName"
                        :rules="[{ required: true, message: '请填写判断依据字段', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.codeName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入判断依据字段"
                            size="small"
                        />
                    </hc-form-item>
                    <hc-form-item
                        label="成功值"
                        prop="successCodeValue"
                        :rules="[{ required: true, message: '请填写成功值', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.successCodeValue"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入成功值"
                            size="small"
                        />
                    </hc-form-item>
                </div>

                <div class="row">
                    <hc-form-item
                        label="错误消息字段"
                        prop="msgName"
                        :rules="[{ required: true, message: '请填写错误消息字段', trigger: ['blur', 'change'] }]"
                    >
                        <hc-input
                            v-model.trim="apiParamObj.response.msgName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入错误消息字段"
                            size="small"
                        />
                    </hc-form-item>
                    <hc-form-item label="数据内容字段" prop="dataName" :rules="rules.dataName">
                        <hc-input
                            v-model.trim="apiParamObj.response.dataName"
                            type="text"
                            :disabled="(isTenantApp && !apiParamObj.isTenant)"
                            placeholder="请输入数据内容字段"
                            size="small"
                        />
                    </hc-form-item>
                </div>
                <div class="row">
                    <hc-form-item
                        v-if="apiParamObj.response.dataType === 'objectArray'"
                        prop="totalName"
                    >
                        <template slot="label">
                            <span>
                                总条数字段
                                <hc-tooltip class="item" effect="dark" content="该字段需要配合列表组件的是否显示总条数来控制" placement="top">
                                    <i class="hc-icon-question" style="margin-left: 2px;font-size: 14px;position: relative;top:1px" />
                                </hc-tooltip>
                            </span>
                        </template>
                        <hc-input
                            v-model.trim="apiParamObj.response.totalName"
                            type="text"
                            :disabled="isTenantApp && !apiParamObj.isTenant"
                            placeholder="请输入总条数字段"
                            size="small"
                        />
                    </hc-form-item>
                </div>
            </hc-form>

            <h4 v-if="apiParamObj.api" class="expand-btn" :class="{'collapse': responseCollapse}" @click="responseCollapse = !responseCollapse">
                高级解析规则
                <i class="el-icon-arrow-down" />
            </h4>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as T from '@common/store/app-resource/types'
import { APP_RESOURCE } from '@common/store/module-types'
import { getObjectField } from '@common/api/app-resource'
import ObjectPicker from '../object/object-picker'
import commonMixin from '../mixins/commom'
import { isParamsType } from '../service/service-management'

const rules = {
    handle: [
        {
            required: true,
            message: '请选择处理方式',
        },
    ],
    objectId: [
        {
            required: true,
            message: '请选择对象',
            trigger: ['blur'],
        },
    ],
    name: [
        {
            required: true,
            message: '参数名称不能为空',
        },
    ],
    dataName: [{ required: true, message: '请填写数据内容字段', trigger: ['blur', 'change'] }],
}

const methodsHasBody = ['post', 'put', 'delete']

export default {
    name: 'PlatformServiceParams',
    components: {
        ObjectPicker,
    },
    mixins: [commonMixin],
    props: {
        varObj: {
            type: Object,
            require: true,
        },
        apiParamObj: {
            type: Object,
            require: true,
        },
        mipApiDetail: {
            type: Object,
        },
        businessEnvId: {
            type: String,
        },
    },
    data() {
        return {
            tableFormObj: {
                tableDataArr: [],
            },
            tableFormHeadersObj: {
                tableDataArr: [],
            },
            tableFormRequestObj: {
                tableDataArr: [],
            },
            rules,
            methodsHasBody,
        }
    },
    computed: {
        appInfo() {
            return this.$store.state.modeling.app
        },

        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },

        isPairType() {
            return this.apiParamObj?.body?.type === 'params' || isParamsType(this.apiParamObj?.body?.contentType)
        },
    },
    watch: {
        'varObj.paramType'() {
            this.getTableDataFn()
        },
        mipApiDetail: {
            immediate: true,
            handler() {
                this.getTableDataFn()
            },
        },
        'apiParamObj.url'() {
            this.$set(this.varObj, 'activeIndex', undefined)
        },
        'apiParamObj'() {
            this.initData()
        },
        // 'tableFormRequestObj.tableDataArr'(v) {
        //     console.log(222, v)
        //     if (!v) return
        //     this.getObjectField(v)
        // },
    },
    mounted() {
        this.appId = this.$route.params.appId
        this.initData()
    },
    methods: {
        initData() {
            const querys = this.apiParamObj?.querys ?? []
            const headers = this.apiParamObj?.headers ?? []
            const paths = this.apiParamObj?.paths ?? []
            this.tableFormRequestObj.tableDataArr = this.apiParamObj?.body?.params ?? []
            const rootRow = this.tableFormRequestObj.tableDataArr[0] || {}
            const { objectId } = rootRow
            // 计算匹配项
            if (objectId) {
                this.getObjectField(rootRow)
            }
            this.tableFormObj.tableDataArr = [
                ...paths.map(item => ({ ...item, paramType: 'UrlPath' })),
                ...headers.map(item => ({ ...item, paramType: 'Header' })),
                ...querys.map(item => ({ ...item, paramType: 'Query' })),
            ]
        },
        ...mapActions(APP_RESOURCE, {
            getObjectField: T.GET_NEW_OBJECT_FIELD,
            getObject: T.GET_NEW_OBJECT,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
        }),
        getNameStr(row) {
            if (row.handle === 'matching' && !row.relevanceMsg.isMatching) return '无匹配项'
            return row.name
        },
        objectClick() {
            this.$refs.tableFormObj && this.$refs.tableFormObj.clearValidate && this.$refs.tableFormObj.clearValidate()
        },
        getRelevanceStr(row) {
            if (row.handle === 'params') return row.objectName
            if (row.handle === 'matching') {
                if (!row.relevanceMsg.isMatching) return '无匹配项'
                return row.relevanceMsg.title
            }
            return '--'
        },
        getHandleText(handle) {
            if (handle === 'params') {
                return '绑定对象'
            }
            if (handle === 'noHandle') {
                return '独立参数'
            }
            return '无'
        },
        rowClassName({ row, rowIndex }) {
            row.index = rowIndex
            this.setChildPath(row, rowIndex)
            return row.disable ? 'row-disable' : ''
        },
        async rowObjectChange(row) {
            if (row.objectId) {
                this.getObjectField(row)
            }
        },
        changeFieldsHandle(row, value, deep = true) {
            const fields = row.fields || []
            fields.forEach(item => {
                item.handle = value
                this.itemHandleChange(item)
                if (value === 'matching' && !row.relevanceMsg.isMatching) {
                    item.relevanceMsg = {
                        isMatching: false,
                        name: '',
                        title: '',
                    }
                }
                if (deep) this.changeFieldsHandle(item, value)
            })
        },
        getObjectField(row) {
            getObjectField({
                objectId: row.objectId,
            }).then(sourceData => {
                const fields = row.fields || []
                const data = sourceData.items
                fields.forEach(item => {
                    item.handle = 'matching'
                    const index = data.findIndex(i => i.name === item.name)
                    if (index === -1) {
                        item.relevanceMsg = {
                            isMatching: false,
                            name: '',
                            title: '',
                        }
                        this.changeFieldsHandle(item, 'matching')
                        return
                    }
                    item.relevanceMsg = {
                        isMatching: true,
                        name: data[index].name,
                        title: data[index].title,
                    }
                    if (item.type === 'object' || item.type === 'objectArray') {
                        this.getObjectField({
                            objectId: data[index]?.typeObjectId,
                            ...item,
                        })
                    }
                })
            })
        },
        setChildPath(row, rowIndex) {
            if (rowIndex === 0) {
                row.path = [0]
            }
            const child = row.fields
            Array.isArray(child) && child.forEach((item, index) => {
                item.path = [...row.path, index]
            })
        },
        getFormItemProp(row, field) {
            const { path = [] } = row
            let result = 'tableDataArr[0]'
            path.forEach((item, index) => {
                if (index === 0) return
                result += `.fields[${item}]`
            })
            return `${result}.${field}`
        },
        changeParamTypeFn(val) {
            this.$set(this.varObj, 'activeIndex', undefined)
            this.$nextTick(() => {
                this.$set(this.varObj, 'paramType', val)
            })
        },
        getTableDataFn() {
            if (methodsHasBody.includes(this.apiParamObj.method) && this.varObj.paramType === 'request') {
                if (!this.apiParamObj.body) {
                    this.apiParamObj.body = {}
                }
                if (this.varObj.requestBody === 'formData') {
                    this.apiParamObj.body.object = {}
                }
                this.$set(this.tableFormObj, 'tableDataArr', this.apiParamObj.body.params)
                return this.apiParamObj.body.params || []
            }
            this.$set(this.tableFormObj, 'tableDataArr', this.apiParamObj[this.varObj.paramType])
            return this.apiParamObj[this.varObj.paramType]
        },
        itemHandleChange(row, value, paramRow = false) {
            if (paramRow) {
                this.$set(row, 'handle', value ? 'pair' : '')
                return
            }
            let disable = false
            // 根结点绑定参数时，下层的非object类型节点都不可操作，对象可操作，所以做了禁用的过滤处理
            let filterObj = false
            if (row.index === 0) {
                disable = row.handle === 'params' || row.handle === 'noHandle'
                filterObj = row.handle === 'noHandle'
                row.name = row.handle === 'params' ? 'postData' : 'root'
            } else {
                disable = row.handle === 'params' || row.handle === 'noHandle' || row.handle === 'matching'
            }
            this.disableChild(row, 'fields', disable, filterObj)
            if (row.index === 0) {
                if (row.handle === 'noHandle') {
                    this.changeFieldsHandle(row, 'params', false)
                    return
                }
                if (row.objectId) {
                    this.getObjectField(row)
                } else {
                    this.changeFieldsHandle(row, 'matching')
                }
            }
        },
        tableRowClick(row) {
            if (row.disable) return
            if (row.index !== this.varObj.activeIndex) {
                // this.$refs.tableFormObj.validate(valid => {
                //     if (valid) {
                //         this.varObj.activeIndex = row.index
                //     }
                // })
            }
            if (this.varObj.activeIndex === undefined) {
                this.$set(this.varObj, 'activeIndex', row.index)
            }
        },
        disableChild(obj, childName, disable, filterObj) {
            const child = obj[childName]
            Array.isArray(child) && child.forEach(item => {
                item.disable = filterObj ? item.type !== 'object' : disable
                this.disableChild(item, childName, disable)
            })
        },
        validate() {
            return this.$refs.responseForm.validate()
        },
        resetFields() {
            this.$refs.tableFormRequestObj && this.$refs.tableFormRequestObj.resetFields()
            this.$refs.responseForm && this.$refs.responseForm.resetFields()
            Array.isArray(this.$refs.tableFormObj) && this.$refs.tableFormObj.forEach(d => d.resetFields())
            this.tableFormObj.tableDataArr = []
            this.tableFormRequestObj.tableDataArr = []
        },
    },
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';
@import url('./common.less');
.custom-title{
    color: #222222;
    font-size: 16px;
    font-weight: 400;
    margin: 32px 0 16px;
}
.param-type__wraper {
    .param-type__item {
        display: inline-block;
        cursor: pointer;
        margin-right: 26px;
        &__icon {
            display: inline-block;
            position: relative;
            border: 2px solid #d3d8e9;
            border-radius: 100%;
            width: 16px;
            height: 16px;
            background-color: #fff;
            cursor: pointer;
            margin-right: 12px;
            box-sizing: border-box;
        }
        &__icon--active {
            border-color: #4c99fe;
        }
        &__icon--active::after {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 100%;
            background-color: #4c99fe;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        > span {
            vertical-align: middle;
        }
    }
}
.handle-text {
    width: 130px;
    display: inline-block;
    text-align: left;
    margin-left: 8px;
    &:first-child {
        margin-left: 0;
    }
}
@{deep} {
    .hc-table__expand-icon {
        width: 20px;
        display: inline-block;
        margin-right: 3px;
        line-height: 20px;
        text-align: center;
    }
    .row-disable {
        cursor: not-allowed;
        opacity: 0.6;
    }
}
.handle {
    display: flex;
    align-items: center;
    .handle-form-item {
        width: 130px;
        margin-left: 8px;
        &.handle-type-input {
            margin-left: 0;
            &.no-handle {
                width: 150px;
            }
        }
    }
}
.large-picker {
    //width: 400px;
    /deep/ .object-picker__body {
        padding-left: 8px;
        font-size: 12px;
        color: #222;
    }
}

.tableFormObjWrapper {
    width: 100%;
    margin-bottom: 20px;

    /deep/ .hc-table {
        th.hc-table__cell.is-leaf {
            border-color: #EAEAEA;
            padding: 8px 0;
            font-size: 13px;
            font-weight: 400;
            background: #FBFBFB;
        }

        .hc-table td.hc-table__cell {
            border-color: #EAEAEA;
        }

        .hc-input__suffix {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .hc-select {
            width: 100%;
        }

        .cell {
            line-height: 32px;
        }

        .hc-icon-arrow-right:before {
            content: "\e791";
        }
    }

    /deep/ .hc-input__suffix-inner {
        line-height: 32px;
    }

    /deep/ .hc-form-item__content {
        line-height: 32px;
    }
}

.new-object .tableFormObjWrapper{
    width: 100%;
    margin-bottom: 20px;

    @{deep} .hc-table .hc-form-item{
        margin: 0;
    }

    @{deep} .hc-table {
        th.hc-table__cell.is-leaf, td.hc-table__cell {
            border-bottom-color: #EAEAEA;
            font-size: 12px;
        }
        th.hc-table__cell.is-leaf {
            background: #FBFBFB;
        }

        .cell {
            padding: 0 12px;
        }

        td.hc-table__cell {
            padding: 12px 0;
        }
        thead {
            font-size: 12px;
            font-weight: 400;
            color: #666;
            th {
                font-weight: 400;
            }
        }
        .hc-table__cell {
            padding: 8px 0;
        }
    }
}

.binary-tip {
    height: 34px;
    line-height: 34px;
    background: rgba(38,110,255,0.1);
    font-size: 12px;
    color: #666;
    padding: 0 14px;
    border-radius: 3px;

    .hc-icon-info {
        &::before {
            display: none;
        }
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #266EFF;
        width: 14px;
        height: 14px;
        border-radius: 100%;
        color: white;
        text-align: center;
        margin-right: 8px;
    }
}
</style>
